export const ONBOARDING_STEPS = {
	PERSONAL_INFO: "onboarding_personal_info",
	ORGANIZATION_INFO: "onboarding_organization_info",
	REGION: "onboarding_region",
	BANK_ACCOUNT: "onboarding_bank_account",
	PRICE_LIST: "onboarding_price_list",
	MIGRATION_DECISION: "onboarding_migration_decision",
	TEAM_INVITE: "onboarding_team_invite",
} as const;

export const ONBOARDING_STATUS = {
	COMPLETED: "completed",
	SKIPPED: "skipped",
	OPEN: "open",
} as const;

export const MIGRATION_DECISION = {
	MIGRATE_FROM_DLXP: "migrate_from_dlxp",
	NO_MIGRATION: "no_migration",
	MIGRATION_DONE: "migration_done",
} as const;